import { render, staticRenderFns } from "./Home_encuerto.vue?vue&type=template&id=33d06f24&scoped=true&"
import script from "./Home_encuerto.vue?vue&type=script&lang=js&"
export * from "./Home_encuerto.vue?vue&type=script&lang=js&"
import style0 from "./Home_encuerto.vue?vue&type=style&index=0&id=33d06f24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d06f24",
  null
  
)

export default component.exports